/**
 * Suggested Question Item component export
 * @remarks
 * Re-exports the container component as the default export.
 */

export { default } from "./SuggestedQuestionItemContainer";
